import React from "react";
import MorphLogo from "app/images/morphLogoWithText.svg";

const BookingHeader = ({ companyName, companyLogo }) => {
  return (
    <header className="public-client-booking-header">
      <div className="public-client-booking-header-inner">
        <div className="public-client-booking-header-left">
          {companyLogo ? (
            <img
              src={companyLogo}
              alt={`${companyName} logo`}
              className="public-client-booking-company-logo"
            />
          ) : null}
          <h1 className="public-client-booking-company-name">{companyName}</h1>
        </div>
        <div className="public-client-booking-header-right">
          <span className="public-client-booking-powered-by">Powered by</span>
          <img
            src={MorphLogo}
            alt="Morph"
            className="public-client-booking-morph-logo"
          />
        </div>
      </div>
    </header>
  );
};

export default BookingHeader;
